<div class="container-xxl gx-0 gx-sm-9 gx-lg-10 gx-xxl-0">
    <div class="row g-0 align-items-center">
        <div class="col-md-6">
            <div class="font-primary px-4 px-md-0 pe-md-4 pe-lg-14">
                <h1 class="mt-10 mt-md-0 fs-md-39 fs-29 fw-700 mb-5">{{ 'OUR_SALOON.title' | translate }}</h1>
                <p class="fs-16 fs-md-19 lh-29 mb-5">{{ 'OUR_SALOON.p1' | translate }}</p>
            </div>
        </div>
        <div class="col-md-6">
            <div class="h-100 overflow-hidden">
                <img class="min-w-100 min-h-100 img-fluid item-md-center" src="assets/images/our_showroom.jpg" alt="" />
            </div>
        </div>
    </div>
</div>
